<template>
  <section>
    <h1 grouped class="title has-text-primary">View/Edit Profile</h1>

    <b-tabs v-model="activeTab">
      <b-tab-item label="Basic Info">
        <!-- <b-field class="file">
          <b-upload v-model="file">
            <a class="button is-primary">
              <b-icon icon="user-circle"></b-icon>
              <span>Upload Profile Picture</span>
            </a>
          </b-upload>
          <span class="file-name" v-if="file">
            {{ file.name }}
          </span>
        </b-field>-->
        <b-field grouped group-multiline>
          <b-field label="Email">
            <b-input v-model="user.email" type="email" disabled icon="envelope"></b-input>
          </b-field>
          <b-field label="First Name">
            <b-input v-model="user.firstName"></b-input>
          </b-field>
          <b-field label="Last Name">
            <b-input v-model="user.lastName"></b-input>
          </b-field>
        </b-field>

        <b-field grouped group-multiline>
          <b-field label="Date of birth">
            <b-datepicker v-model="user.dateOfBirth" icon="calendar"></b-datepicker>
          </b-field>
          <b-field label="Gender">
            <b-select v-model="user.gender" placeholder="Gender">
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </b-select>
          </b-field>
        </b-field>

        <b-field label="Occupation">
          <b-input v-model="user.occupation"></b-input>
        </b-field>

        <b-field grouped group-multiline>
          <b-field label="Country of Origin">
            <b-select
              v-model="user.countryOfOrigin"
              icon="globe-americas"
              placeholder="Select Country"
              required
            >
              <option v-for="c in listOfCountries" v-bind:key="c">{{c}}</option>
            </b-select>
          </b-field>
          <b-field label="Country of Citizenship">
            <b-select
              v-model="user.countryOfCitizenship"
              icon="globe-americas"
              placeholder="Select Country"
              required
            >
              <option v-for="c in listOfCountries" v-bind:key="c">{{c}}</option>
            </b-select>
          </b-field>
        </b-field>

        <b-field grouped group-multiline>
          <b-field label="Mobile Phone #">
            <b-input v-model="user.phoneMobile" type="phone" icon="phone"></b-input>
          </b-field>
          <b-field label="Home Phone #">
            <b-input v-model="user.phoneHome" type="phone" icon="phone"></b-input>
          </b-field>
          <b-field label="Work Phone #">
            <b-input v-model="user.phoneWork" type="phone" icon="phone"></b-input>
          </b-field>
        </b-field>

        <!-- <b-field grouped group-multiline>
          <b-field label="Home Address">
            <b-input placeholder="Home Address" expanded
              type="address"
              maxlength="40">
            </b-input>
          </b-field>
          <b-field label="City">
            <b-input placeholder="City" expanded></b-input>
          </b-field>
          <b-field label="State">
            <b-input placeholder="State" expanded></b-input>
          </b-field>
          <b-field label="Zip Code">
            <b-input placeholder="Zip Code" expanded></b-input>
          </b-field>
        </b-field>-->
        <b-field label="Biography">
          <b-input type="textarea" v-model="user.biography"></b-input>
        </b-field>

        <!-- TO-DO: Hook up to API -->
        <hr>
        <h4 class="title is-4">Emergency Contacts</h4>
        <h6 class="subtitle is-6 has-text-danger">Minimum of 2 required for mission trips</h6>
        <b-field grouped group-multiline>
          <b-field label="Name">
            <b-input v-model="emergencyName"></b-input>
          </b-field>
          <b-field label="Phone #">
            <b-input icon="phone" type="phone" v-model="emergencyPhone"></b-input>
          </b-field>
          <b-field label="Relationship">
            <b-input v-model="emergencyRelationship"></b-input>
          </b-field>
        </b-field>
        <button class="button is-primary" @click="addEmergencyContact">Add</button>
        <br /><br />
        <b-table :data="user.emergencyContacts">
          <template slot-scope="props">
            <b-table-column field="name" label="Name" width=50>
              {{ props.row.name }}
            </b-table-column>
            <b-table-column field="phone" label="Phone" width=150>
              {{ props.row.phone }}
            </b-table-column>
            <b-table-column field="relationship" label="Relationship" width=150>
              {{ props.row.relationship }}
            </b-table-column>
            <b-table-column label="Remove" width=200>
              <button class="button is-danger is-small" @click="removeEmergencyContact(props.row)">Remove</button>
            </b-table-column>
          </template>
        </b-table>

        <hr>
        <h4 class="title is-4">Social Media</h4>
        <b-field grouped group-multiline>
          <b-field label="App">
            <b-select placeholder="Select App" rounded v-model="socialMediaSelection">
              <option value="Viber">Viber</option>
              <option value="Skype">Skype</option>
              <option value="FireChat">FireChat</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Other">Other</option>
            </b-select>
          </b-field>
          <b-field label="App Name" v-if="socialMediaSelection === 'Other'">
            <b-input placeholder="Skype" v-model="otherSocialMediaType"></b-input>
          </b-field>
          <b-field label="Handle">
            <b-input placeholder="bob123" v-model="socialMediaHandle"></b-input>
          </b-field>
        </b-field>
        <button class="button is-primary" @click="addSocialMedia">Add</button>
        <br /><br />
        <b-table :data="user.socialMedia">
          <template slot-scope="props">
            <b-table-column field="app" label="App Name" width=50>
              {{ props.row.app }}
            </b-table-column>
            <b-table-column field="handle" label="Handle" width=150>
              {{ props.row.handle }}
            </b-table-column>
            <b-table-column label="Remove" width=200>
              <button class="button is-danger is-small" @click="removeSocialMedia(props.row)">Remove</button>
            </b-table-column>
          </template>
        </b-table>

        <br />

        <button class="button is-success" @click="save">
          <span>Save</span>
        </button>
      </b-tab-item>

      <b-tab-item label="Documents">
        <section>
          <b-table
            :data="documentTips"
            bordered
            striped
            narrowed
            hoverable
            mobile-cards
          >
            <template slot-scope="props">
              <b-table-column label="Document" numeric>{{ props.row.label }}</b-table-column>
              <b-table-column label="Required for Mission Trip?">
                <b-icon :icon="props.row.requiredForMission === true ? 'check' : 'times'" width="40"></b-icon>
              </b-table-column>
              <b-table-column field="s3UploadCategory" label="Upload">
                <template v-if="props.row.hasMany">
                  <div class='button-spacing' v-bind:key="document.key"
                    v-for="document in user.uploads[props.row.s3UploadCategory]"
                  >
                    <UploadAndViewFile
                      :s3UploadCategory="props.row.s3UploadCategory"
                      :prefix="document.key"
                      :btnViewText="getBtnViewText(document.key)"
                    />
                  </div>
                  <UploadAndViewFile
                    :s3UploadCategory="props.row.s3UploadCategory"
                    :onlyShowFileUpload=true
                  />
                </template>
                <template v-if="!props.row.hasMany">
                  <UploadAndViewFile
                    :s3UploadCategory="props.row.s3UploadCategory"
                    :btnViewText="getBtnViewText(props.row.s3UploadCategory)"
                  />
                </template>
              </b-table-column>
            </template>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                  </p>
                  <p>Nothing here.</p>
                </div>
              </section>
            </template>
          </b-table>
        </section>

        <br />
        <a class="button is-success" @click="save">
          <span>Save</span>
        </a>
      </b-tab-item>
      <b-tab-item label="Practitioner">
        <h4 class="title is-4">Work Information</h4>

        <b-field label="Clinic Name">
          <b-input v-model="user.workName"></b-input>
        </b-field>

        <b-field label="Address 1">
          <b-input v-model="user.workStreet1"></b-input>
        </b-field>
        <b-field label="Address 2">
          <b-input v-model="user.workStreet2"></b-input>
        </b-field>

        <b-field grouped group-multiline>
          <b-field label="City">
            <b-input v-model="user.workCity"></b-input>
          </b-field>
          <b-field label="State">
            <b-input v-model="user.workState"></b-input>
          </b-field>
          <b-field label="Zip Code">
            <b-input v-model="user.workZip"></b-input>
          </b-field>
        </b-field>

        <hr>

        <b-field label="Specialties">
          <b-field>
            <b-input v-model="user.specialities"></b-input>
          </b-field>
        </b-field>

        <b-field label="Degree(s)">
          <b-field>
            <b-checkbox v-model="user.degrees" native-value="AS">AS</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="BS">BS</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="MS">MS</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="PhD">PhD</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="MBA">MBA</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="MD">MD</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="DDS">DDS</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="OD">OD</b-checkbox>
            <b-checkbox v-model="user.degrees" native-value="RPH">RPH</b-checkbox>
          </b-field>
        </b-field>

        <br />

        <button class="button is-success" @click="save">
          <span>Save</span>
        </button>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ListOfCountries from '@/utils/ListOfCountries';
import { S3_UPLOAD_CATEGORIES } from '@/utils/Enums';
import _ from 'lodash';
import ValidationUtil from '../utils/ValidationUtil';
import UploadAndViewFile from '@/components/UploadAndViewFile';
import PropTypes from 'prop-types';

export default {
  components: {
    UploadAndViewFile,
  },
  created() {
    this.setIsLoading(true);
  },
  mounted() {
    this.setIsLoading(false);
  },
  data() {
    return {
      emergencyPhone: null,
      emergencyName: null,
      emergencyRelationship: null,
      socialMediaSelection: null,
      otherSocialMediaType: null,
      socialMediaHandle: null,
      listOfCountries: ListOfCountries.map((c) => {
        return c.name;
      }),
      activeTab: null,
      documentTips: _.map(
        _.omit( S3_UPLOAD_CATEGORIES, [ 'profilePic', 'waivers' ] ),
        ( key ) => key
      ),
    };
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    ...mapMutations(['setIsLoading']),
    addEmergencyContact() {
      this.user.emergencyContacts.push({
        name: this.emergencyName,
        phone: this.emergencyPhone,
        relationship: this.emergencyRelationship,
      });
      this.emergencyName = null;
      this.emergencyPhone = null;
      this.emergencyRelationship = null;
    },
    removeEmergencyContact(emergencyContact) {
      this.user.emergencyContacts = _.remove(this.user.emergencyContacts, (e) => {
        return e.name !== emergencyContact.name
        && e.phone !== emergencyContact.phone
        && e.relationship !== emergencyContact.relationship;
      });
    },
    addSocialMedia() {
      if (this.socialMediaSelection !== 'Other') {
        this.user.socialMedia.push({
          app: this.socialMediaSelection,
          handle: this.socialMediaHandle,
        });
      } else {
        this.user.socialMedia.push({
          app: this.otherSocialMediaType,
          handle: this.socialMediaHandle,
        });
      }
      this.socialMediaSelection = null;
      this.otherSocialMediaType = null;
      this.socialMediaHandle = null;
    },
    removeSocialMedia(socialMedia) {
      this.user.socialMedia = _.remove(this.user.socialMedia, (s) => {
        return s.app !== socialMedia.app && s.handle !== socialMedia.handle;
      });
    },
    save() {
      this.setIsLoading(true);
      this.axios
        .post(
          `https://p2p3e209fb.execute-api.us-east-1.amazonaws.com/dev/users/${
            this.user.userId
          }`,
          this.user,
        )
        .then((res) => {
          this.setIsLoading(false);
          this.$toast.open('Saved!');
        });
    },
    getBtnViewText(documentKey) {
      return `View ${documentKey}`;
    },
  },
};
</script>
<style lang="scss">
  .view-file {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .button-spacing {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
